// User roles for access control
export type UserRole = "Sales" | "Purchase";

// Aggregate fields that can be requested in grouped GraphQL queries
export type AggregationField = "revenue" | "quantity" | "cost" | "profit";

// Default role when no role is assigned (most restrictive)
export const DEFAULT_ROLE: UserRole = "Sales";

// Role hierarchy - higher index = more permissions
export const ROLE_HIERARCHY: UserRole[] = ["Sales", "Purchase"];

// Azure AD App Role claim names (as configured in App Registration)
export const AZURE_AD_ROLE_CLAIM = "roles";

// Map Azure AD role names to application roles
export const AZURE_AD_ROLE_MAP: Record<string, UserRole> = {
  Sales: "Sales",
  Purchase: "Purchase",
  // Add aliases if your Azure AD roles have different names
  SalesManager: "Sales",
  PurchaseManager: "Purchase",
  Finance: "Purchase",
};

// Query-level aggregation permissions by role.
export const ROLE_AGGREGATION_ACCESS: Record<UserRole, AggregationField[]> = {
  Sales: ["revenue", "quantity"],
  Purchase: ["revenue", "quantity", "cost", "profit"],
};
